import { LOCAL_ENVIRONMENTS } from '@/app/env-constants'
import { getEnv } from '@/app/get-env'

const BASE_TITLE = 'Scope TRACTIAN'

// Sets the tab title from the runtime environment. index.html ships the
// prod title statically; this re-prefixes it for non-prod hostnames once the
// bundle boots. Homolog and unknown hostnames fall through getEnv()'s safe
// default ('development') and get [DEV].
export const applyTabTitle = () => {
  if (LOCAL_ENVIRONMENTS.includes(window.location.hostname)) {
    document.title = `[LOCAL] ${BASE_TITLE}`
    return
  }
  if (getEnv() === 'production') {
    document.title = BASE_TITLE
    return
  }
  document.title = `[DEV] ${BASE_TITLE}`
}
